(function () {
    'use strict';
    $(document).ready(function () {
        var $opened = null;
        var $li = null;
        var opening = false;
        $('.main-menu-container .main-menu >li.menu-item-has-children >a').on('click', function () {
            $li = $(this).parent();
            if ($opened) {
                if ($opened.is($li)) {
                    $('.homepage, .subpage').removeClass('make-overlay');
                    $li.find('.menu-box').fadeOut();
                    $li.find('>ul').fadeOut();
                    $opened = null;
                    $('li.opened').removeClass('opened');

                } else {
                    $('.homepage, .subpage').addClass('make-overlay');
                    $opened.find('.menu-box').fadeOut();
                    $opened.find('>ul').fadeOut(function () {
                        $li.find('.menu-box').fadeIn();
                        $li.find('>ul').fadeIn();
                        $opened = $li;
                        $('li.opened').removeClass('opened');
                        $li.addClass('opened');
                    });
                }
            } else {
                $('.homepage, .subpage').addClass('make-overlay');
                $li.find('.menu-box').fadeIn();
                $li.find('>ul').fadeIn();
                $opened = $li;
                $opened.addClass('opened');
            }
            return false;
        });

        $('.homepage, .subpage, header').on('click', function() {
            if ($('.homepage').hasClass('make-overlay') || $('.subpage').hasClass('make-overlay')) {

                $('.homepage').removeClass('make-overlay');
                $('.subpage').removeClass('make-overlay');

                var $li = $('.main-menu-container .main-menu > li.menu-item-has-children.opened');
                $li.find('.menu-box').fadeOut();
                $li.find('>ul').fadeOut();
                $opened = null;
                $('li.opened').removeClass('opened');
            }
        });

        // $('.main-menu-container .main-menu >li.menu-item-has-children').hover(function () {
        //     //hover
        //     $li = $(this);
        //
        //     if ($opened) {
        //         if ($opened.is($li)) {
        //             $li.find('.menu-box').fadeOut(100);
        //             $li.find('>ul').fadeOut(100);
        //             $opened = null;
        //             $('li.opened').removeClass('opened');
        //
        //         } else {
        //             $opened.find('.menu-box').fadeOut(100);
        //             $opened.find('>ul').fadeOut(function () {
        //                 $li.find('.menu-box').fadeIn(100);
        //                 $li.find('>ul').fadeIn(100);
        //                 $opened = $li;
        //                 $('li.opened').removeClass('opened');
        //                 $li.addClass('opened');
        //             }, 100);
        //         }
        //     } else {
        //         $li.find('.menu-box').fadeIn(0);
        //         $li.find('>ul').fadeIn(0);
        //         $opened = $li;
        //         $opened.addClass('opened');
        //     }
        // }, function () {
        //     // mouse out
        //     $li = $(this);
        //     if ($opened) {
        //         $li.find('.menu-box').fadeOut(100);
        //         $li.find('>ul').fadeOut(100);
        //         $opened = null;
        //         $('li.opened').removeClass('opened');
        //     }
        // });

        $('#top-menu > li.orange-bg > a').on('click', function (e) {
            e.preventDefault();
        });

        $('.main-menu-container .main-menu > li > ul').mCustomScrollbar({
            axis: "y",
            mouseWheel: {
                enable: true
            }
        });

        $('.main-menu-mobile-container .main-menu >li.menu-item-has-children >a').click(function (e) {
            var $li = $(this).parent();
            $li.toggleClass('clicked');
            $li.find('>ul').slideToggle();
            e.preventDefault();
        });

        $('.main-menu-container .main-menu >li.menu-item-has-children >a').click(function (e) {
            //e.preventDefault();
        });

        $('.hamburger').click(function () {
            var mobileOpened = $(this).hasClass('active');
            $('.hamburger').toggleClass('active');
            if (mobileOpened) {
                $('.mobile-panel .panel-content').slideUp(function () {
                    $('header').removeClass('menu-opened');
                    mobileOpened = false;
                });
            } else {
                $('header').addClass('menu-opened');
                $('.mobile-panel .panel-content').slideDown();
                mobileOpened = true;
            }
        });

        $('.support-mobile .support-btn').on('click', function () {
            $('.support-mobile .support-list').fadeToggle();
        });

        $('.scroll-up, .scroll-to-top').click(function () {
            if($('.hamburger').hasClass('active'))
                $('.hamburger').click();

            $('html, body').animate({scrollTop: 0}, 'slow');
            return false;
        });

        $('.prettySocial').prettySocial();

        $('.open').click(function () {
            var parent = $(this).parent();
            var popup = parent.children('.share-popup');
            popup.fadeToggle();
        });

        $('.newsletter-trigger').click(function() {
            $('.newsletter-container').slideDown(function(){
                $('body').on('click', closeNewsletter);
            });
        });

        $('.close-newsletter').click(closeNewsletter);

        $('#newsletter_form').ajaxForm(function() {
            $('.newsletter-container').slideUp();
        });

        $('.fbsharelink').click( function()
        {
            var shareurl = $(this).data('url');
            var title = $(this).data('title');
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + escape(shareurl) + '&t=' + title, '',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            return false;
        });


        function closeNewsletter(e) {
            if (e.target.id === "newsletter_container" || $(e.target).parents("#newsletter_container").length) {
                if (e.target.id === 'close_newsletter') {
                    $('.newsletter-container').slideUp();
                    $('body').off('click', closeNewsletter);
                }
            } else {
                $('.newsletter-container').slideUp();
                $('body').off('click', closeNewsletter);
            }
        }

        var hash = document.location.hash;
        var prefix = "tabs_";
        if (hash) {
            var tab_id = hash.replace(prefix,"");
            $(".nav-tabs a[href='"+tab_id+"']").tab('show');
        }

        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            window.location.hash = e.target.hash.replace("#", "#" + prefix);
        });

    });

    $(window).on('scroll load', function () {
        var staticMenuOffset = 150;

        if ($(window).width() < 767) {
            staticMenuOffset = 55;
        }else{
            if ($(document).scrollTop() >= $(window).height()) {
                $('.scroll-to-top').addClass('active');
            } else {
                $('.scroll-to-top').removeClass('active');
            }
        }

        if ($(document).scrollTop() >= staticMenuOffset) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }

    });

}(jQuery));
